import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"copy") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"block-container\">\n        <div class=\"block\">\n          <div class=\"block-inner\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"buttonID") : depth0), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"src") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":12},"end":{"line":16,"column":19}}})) != null ? stack1 : "")
    + "          </div>\n          <p class=\"link\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n        </div>\n      </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"image\">\n              <img height=\"100%\" width=\"100%\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "\" alt=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\" />\n            </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\" id=\"connect-container\">\n  <div class=\"column small-12 large-10 centered\">\n    <h4 id=\"heading\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headingClass") : stack1), depth0))
    + "\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":6,"column":13}}})) != null ? stack1 : "")
    + "    <div class=\"blocks-container\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"blocks") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":6},"end":{"line":21,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n  </div>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/three-column-cc-module",
  "version": "2.0.0",
  "id": "threeColumnCCModule",
  "containerID": "creditCardsThreeColumnCcModule",
  "moduleName": "credit-cards-three-column-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "three-column-cc-module",
  "data": {
    "init": "threeColumnCCModuleJS"
  },
  "moduleParams": [{
    "name": "checkPilotZip",
    "type": "boolean",
    "default": false,
    "description": "Check to see if we should be changing the phone number for whatever reason."
  }, {
    "name": "extend-bottom-margin",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Adds extended margin to the bottom of the module."
  }, {
    "name": "show-social",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Displays social section when true or unspecified."
  }, {
    "name": "skin",
    "type": "string",
    "values": ["warm", "cool", "cool-inverted", "none"],
    "default": "none",
    "description": "New skin, warm is from the older color palette, cool is the new 2017 colors."
  }, {
    "name": "small-centered",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Centers the box content in small view."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0"
  },
  "stores": []
};

class ThreeColumnCcModule extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: ThreeColumnCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ThreeColumnCcModule as default, moduleConfig };
